<template>
  <div role="group" class="b-form-group form-group">
    <div class="form-row mb-lg">
      <div class="col-sm-12">
        <b-form-fieldset v-bind:label="$t('EDUCATIONALGROUP')">
          <inputvalidation :formerror="formError" name="educationalGroupId">
              <lb-vue-select v-model= "formData.educationalGroupId"
                              :list= "educationalGroup.root"
                              display-field= "name"
                              value-field= "educationalGroupId"
                              :items-placeholder= "$t('EDUCATIONALGROUP')">
                </lb-vue-select>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('NAME')">
          <inputvalidation :formerror="formError" name="name">
            <b-form-input type="text" v-model="formData.name"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('SURNAME')">
          <inputvalidation :formerror="formError" name="surname">
            <b-form-input type="text" v-model="formData.surname"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
    <div class="form-row mb-lg">
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('CONTACTNUMBER')">
          <inputvalidation :formerror="formError" name="contactNumber">
            <b-form-input type="text" v-model="formData.contactNumber"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
      <div class="col-sm-6">
        <b-form-fieldset v-bind:label="$t('EMAIL')">
          <inputvalidation :formerror="formError" name="email">
            <b-form-input type="email" v-model="formData.email"></b-form-input>
          </inputvalidation>
        </b-form-fieldset>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'EducatorForm',
    props: ['formData', 'formError', 'educationalGroup'],
};
</script>
